module.exports = __webpack_public_path__ + "img/1.5bb4e57d.jpg";